import { createFileRoute } from "@tanstack/react-router";
import { ActivityPage } from "../features/activity/activity-page";
import { Require } from "../features/require";

/** More > Activity log (P11-T11), owners and managers. */
export const Route = createFileRoute("/more/activity")({ component: Page });

function Page() {
	return (
		<Require permission="audit.view">
			<ActivityPage />
		</Require>
	);
}
